import { ContractOriginEnum } from '@/graphql/contracts/_generated_/contracts';
import { ContractLineToCreate, VariableContractLineToCreate } from './useCreateContractLine';

export const mapFieldsToCreateContractLine = (contractLineToCreate: ContractLineToCreate[], 
  contractOrigin?: ContractOriginEnum | null) => {
  const contractLinesToBeCreated = contractLineToCreate.map(contractLine => ({
    billingInterval: contractLine.billingInterval?.billingInterval,
    billingStartDate: contractLine.billingStartDate,
    billingType: contractLine.billingType?.type,
    comments: contractLine.comments,
    stockCode: contractLine.stockCode!.stockCode,
    unitPrice: contractLine.unitPrice,
    lineStartDate: contractLine.lineStartDate,
    unitPriceFrequency: contractLine.unitPriceFrequency?.frequency,
    quantity: contractLine.quantity,
    shipToCustomerId: contractLine.shipToCustomer?.customerID,
    invoiceToCustomerId: contractLine.invoiceToCustomer?.customerID,
    invoiceToCustomerAccountNumber: contractLine.invoiceToCustomer?.customerAccountNumber,
    unitType: contractLine.unitType,
    poNumber: contractLine.poNumber,
    proRataEndDate: contractLine.proRataEndDate,
    origin: contractOrigin,
  }));
  return contractLinesToBeCreated;
};

export const mapFieldsToCreateVariableContractLine = (contractLineToCreate: VariableContractLineToCreate[], 
  contractOrigin?: ContractOriginEnum | null) => {
  const contractLinesToBeCreated = contractLineToCreate.map(contractLine => ({
    billingInterval: contractLine.billingInterval?.billingInterval,
    billingStartDate: contractLine.billingStartDate,
    billingType: contractLine.billingType?.type,
    comments: contractLine.comments,
    stockCode: contractLine.stockCode!.stockCode,
    unitPrice: contractLine.unitPrice,
    lineStartDate: contractLine.lineStartDate,
    shipToCustomerId: contractLine.shipToCustomer?.customerID,
    invoiceToCustomerId: contractLine.invoiceToCustomer?.customerID,
    invoiceToCustomerAccountNumber: contractLine.invoiceToCustomer?.customerAccountNumber,
    unitType: contractLine.unitType,
    poNumber: contractLine.poNumber,
    origin: contractOrigin,
  }));
  return contractLinesToBeCreated;
};
